



import {
  Component, Vue, Prop, Watch,
} from 'vue-property-decorator';
import type { CssGenerator } from '@/logic/CSSGenerator';

@Component
export default class CssInjector extends Vue {
  @Prop({ required: true })
  generator!: CssGenerator;

  sheet!: HTMLStyleElement;

  // Watch the 'dirty' marker for updates
  @Watch('generator.modificationCounter')
  @Watch('generator')
  onStyleChange() {
    this.sheet.innerHTML = this.generator.renderCss();
  }

  mounted() {
    this.sheet = document.createElement('style');
    this.sheet.setAttribute('scoped', 'true');
    this.$el.appendChild(this.sheet);
    this.onStyleChange();
  }
}
